import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IconButton, Menu, MenuItem, Typography } from "@mui/material";
import socket from "../../shared/utils/Socket"; // adjust the path

import AccountCircleIcon from "@mui/icons-material/AccountCircle";

import Swal from "sweetalert2";
import axios from "axios";

import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import { Mail } from "../../shared/assets/icons";

const Navbar = ({ isOpen, setIsOpen, setLoading }) => {
  const location = useLocation();
  const activeMenu = location.pathname.split("/").pop();
  const userRole = localStorage.getItem("role");
  const name = localStorage.getItem("name");
  const email = localStorage.getItem("email");
  const navigate = useNavigate();
  const serverURL = process.env.REACT_APP_URL;

  const getActiveMenuName = () => {
    const menu = activeMenu.toLowerCase();
    switch (menu) {
      case "dashboard":
        return "Dashboard";
      case "map":
        return "MAP";
      case "installation-partner":
        return "Installation Partner";
      case "contractor":
        return "Contractor";
      case "team":
        return "Team";
      case "itemMaster":
        return "Item Master";
      case "vendordetails":
        return "Vendor Details";
      case "clientdetails":
        return "Organization Details";
      case "campaign":
        return "Campaigns";
      case "enquiry":
        return "Enquiry";
      case "pdi":
        return "PDI";
      case "payments":
        return "Payments";
      case "RecceApprove":
        return "RecceApprove";
      case "jobBatches":
        return "JOB BATCHES";
      case "locationsVerification":
        return "Location Verification";
      case "deliverycenters":
        return "Delivery Centers";
      case "installation-flag":
        return "Installation Flag";
      default:
        return "";
    }
  };
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    Swal.fire({
      text: "Are you sure you want to Logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        try {
          // Hit the logout API using Axios
          const response = await axios.post(`${serverURL}/api/auth/logout`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          });
          if (response.status === 200) {
            // If the API call was successful, clear local storage
            if (socket.connected) {
              socket.disconnect();
            }

            setLoading(false);
            Swal.fire({
              text: response.data.message,
              icon: "success",
            }).then(() => {
              localStorage.clear();
              navigate("/adminportal");
            });
          } else {
            // Handle unsuccessful responses
            Swal.fire({
              text: "Failed to logout. Please try again.",
              icon: "error",
            });
          }
        } catch (error) {
          // Handle any network errors or exceptions
          console.error("Logout error:", error);
          Swal.fire({
            text: "An error occurred. Please try again.",
            icon: "error",
          });
        }
      }
    });
  };
  const getDotColor = () => {
    switch (userRole) {
      case "-1": // SUPER ADMIN
        return "var(--textChip-green-color)";
      case "0": // ADMIN and PM
        return "var(--Golden-color)";
      case "1": //  MT AND BD
        return "var(--para-color)";
      case "3": // PURCHASE
        return "#8B5CF6";
      case "4":
        return "#8b0098";
      case "5":
        return "#0a0607";
      case "6":
        return "#323aa8";
      case "7":
        return "#323aa8";

      default:
        return "var(--error-color)"; // Default color if no role is matched
    }
  };

  return (
    <div
      className={`flex flex-grow  justify-between items-center max-w-full text-white p-2 ${
        isOpen ? `ml-64 translate-x ` : `ml-14`
      } `}
      style={{ background: "var(--primary-color)", height: "7vh" }}
    >
      <div className="ml-4">
        <img
          src="/assests/pixell white logo.png"
          alt="pixell Logo"
          width={80}
          height={80}
        />
      </div>

      <div className="menu-name text-xl font-semibold hidden sm:block">
        {getActiveMenuName()}
      </div>
      <div style={{ position: "relative", display: "inline-block" }}>
        <IconButton onClick={handleMenuOpen}>
          <AccountCircleIcon sx={{ fontSize: 40, color: "white" }} />
        </IconButton>
        <div
          style={{
            position: "absolute",
            top: 7,
            right: 10,
            height: 12,
            width: 12,
            backgroundColor: getDotColor(),
            borderRadius: "50%",
            animation: "pulse 1.5s infinite",
            border: "1px solid white",
          }}
        ></div>
        <style>
          {`
          @keyframes pulse {
            0%, 100% {
              transform: scale(0.7);
              opacity: 1;
            }
            50% {
              transform: scale(1); /* Expanded size */
              opacity: 1; /* Slightly faded */
            }
          }
        `}
        </style>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          PaperProps={{
            style: {
              padding: "10px",
              borderRadius: "8px",
            },
          }}
        >
          <div className="flex-row justify-start items-center  ">
            <div className="flex gap-1 items-center justify-start">
              <PersonOutlineOutlinedIcon
                sx={{
                  fontSize: 20,
                  fontWeight: 100,
                }}
              />

              <p className="text-[14px] font-semibold text-[var(--heading-color)]">
                {name?.charAt(0)?.toUpperCase() + name?.slice(1)}
              </p>
            </div>
            <div className="flex gap-2 items-center justify-start ml-0.5 mt-1">
              <Mail color="black" size="14" />

              <Typography variant="body2" color="text.secondary">
                {email}
              </Typography>
            </div>
            <div className="border w-full my-1"></div>
            <MenuItem
              onClick={() => {
                handleLogout();
                handleMenuClose();
              }}
              sx={{
                mt: 1,
                bgcolor: "var(--error-color)", // Initial background color
                color: "white",
                borderRadius: "4px",
                justifyContent: "center",
                "&:hover": {
                  bgcolor: "var(--para-color)", // Set your hover background color
                },
              }}
            >
              Logout
            </MenuItem>
          </div>
        </Menu>
      </div>
    </div>
  );
};

export default Navbar;
